import { apiClient } from '../../lib/api-client';
import type { AuthUser } from '../../stores/auth-store';

export interface AuthTokens {
  accessToken: string;
  expiresIn: number;
}

export interface AuthResponse {
  user: AuthUser;
  tokens: AuthTokens;
}

export interface TotpRequiredResponse {
  status: 'totp_required';
}

export type LoginResponse = AuthResponse | TotpRequiredResponse;

export function isTotpRequired(resp: LoginResponse): resp is TotpRequiredResponse {
  return 'status' in resp && resp.status === 'totp_required';
}

export interface LoginPayload {
  email: string;
  password: string;
  totpCode?: string;
}

export interface SignupPayload {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
}

export const authApi = {
  async login(payload: LoginPayload): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/v1/auth/login', payload);
    return data;
  },

  async signup(payload: SignupPayload): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/v1/auth/signup', payload);
    return data;
  },

  async me(): Promise<AuthUser> {
    const { data } = await apiClient.get<AuthUser>('/v1/auth/me');
    return data;
  },

  async logout(): Promise<void> {
    await apiClient.post('/v1/auth/logout');
  },
};
